var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"d-flex"},[_c('v-btn',{attrs:{"color":"primary","to":"/","text":""}},[_c('v-icon',{attrs:{"left":"","dark":""},domProps:{"textContent":_vm._s('mdi-arrow-left')}}),_vm._v("\n      "+_vm._s(_vm.local.linkLabel)+"\n    ")],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }